import { Route } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { RoleGuard } from '../guards/role.guard';

export const reportsRoutes: Route[] = [
  {
    path: 'reports/donation-reports/individuals-clothes-reports',
    loadComponent: () =>
      import(
        '../../features/reports/donations-reports/pages/individuals-clothes-reports/individuals-clothes-reports'
      ).then((mod) => mod.IndividualsClothesReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'reports/donation-reports/individuals-furniture-reports',
    loadComponent: () =>
      import(
        '../../features/reports/donations-reports/pages/individuals-furniture-reports/individuals-furniture-reports'
      ).then((mod) => mod.IndividualsFurnitureReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'reports/donation-reports/corps-clothes-reports',
    loadComponent: () =>
      import(
        '../../features/reports/donations-reports/pages/corps-clothes-reports/corps-clothes-reports'
      ).then((mod) => mod.CorpsClothesReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'reports/donation-reports/corps-furniture-reports',
    loadComponent: () =>
      import(
        '../../features/reports/donations-reports/pages/corps-furniture-reports/corps-furniture-reports'
      ).then((mod) => mod.CorpsFurnitureReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'reports/users-orders-reports',
    loadComponent: () =>
      import(
        '../../features/reports/beneficiaries-reports/pages/users-orders-reports/users-orders-reports'
      ).then((mod) => mod.UsersOrdersReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'reports/stock-reports',
    loadComponent: () =>
      import(
        '../../features/reports/stock-reports/pages/stock-reports/stock-reports'
      ).then((mod) => mod.StockReports),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
  {
    path: 'product-details/:productId',
    loadComponent: () =>
      import(
        '../../features/reports/stock-reports/pages/product-details/product-details'
      ).then((mod) => mod.ProductDetails),
    pathMatch: 'full',
    canActivate: [AuthGuard, RoleGuard],
    data: {
      allowedRoles: ['superAdmin', 'supervisor'],
    },
  },
];
